<script setup>
import router from '@/router';
import { BModal, BFormInput,  BFormTextarea, BFormSelect, BRow, BCol, BButton } from 'bootstrap-vue-next'
import { defineModel,reactive, inject,} from 'vue'

const modal = defineModel()
const data = reactive({
    item_name : '',
    type : '',
    initial_stock : null,
})
const repositories = inject('repositories');

const inventoryRepository = repositories ? repositories.inventory : null;
const create = () => {
        console.log(`Reservation Form: ${JSON.stringify(data)}`)
        
        inventoryRepository.create(data).then(() => {
          router.go(0)
        }).catch(err => {
          console.error(err)
        })
      }


</script>

<template>
    <BModal id="modal-tall" size="lg" v-model="modal" centered title="Inventory" @update:modelValue="updateModal"> 
        <div class="d-flex flex-column gap-3">
            <BFormInput type="text" v-model="data.item_name" placeholder="Name"></BFormInput>
            <BRow>
                <BCol>
                    <BFormSelect class=" form-control" v-model="data.type" :options="theType"></BFormSelect>
                </BCol>
                <BCol>
                    <BFormInput type="number" v-model="data.initial_stock"></BFormInput>
                </BCol>
            </BRow>
            <BFormTextarea type="text-field" placeholder="Remark"></BFormTextarea>
        </div>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="create" class="mr-2">Save</BButton>
                <BButton variant="danger" @click="modal = false">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
const theType = [
    { value: '-', text: 'Choose Category' },
    { value: 'product', text: 'Product' },
    { value: 'item', text: 'item' },
]
</script>